import { Edit, RefreshButton, SaveButton, useForm } from '@refinedev/antd';
import { useMemo } from 'react';

import ProtectedDeleteButton from '@/components/protected/ProtectedDeleteButton';
import { COUNTRY, useCountryContext } from '@/contexts/CountryContext';
import { Shipper } from '@/model/Logistic/Shipper/Shipper';

import ShipperForm from './ShipperForm/ShipperForm';

const ShipperEdit = () => {
  const { formProps, saveButtonProps, query } = useForm<Shipper>();
  const { isBrasilSelected } = useCountryContext();
  const record = query?.data?.data;
  // Transforma la respuesta del backend (localidad como objeto anidado) a IDs planos
  // para que el formulario y los selects puedan inicializarse correctamente.
  // Si el shipper no tiene localidad, se usa el país del contexto como fallback.
  const initialValuesModified = useMemo(
    () =>
      record
        ? {
            ...record,
            localidad: record.localidad?.id,
            provincia: record.localidad?.provincia?.id,
            pais:
              record.localidad?.provincia?.pais?.id ??
              (isBrasilSelected ? COUNTRY.BRASIL : COUNTRY.ARGENTINA),
          }
        : undefined,
    [record, isBrasilSelected],
  );

  return (
    <Edit
      saveButtonProps={saveButtonProps}
      isLoading={query?.isLoading || query?.isFetching}
      footerButtons={({ deleteButtonProps }) => (
        <>
          <ProtectedDeleteButton {...deleteButtonProps} />
          <SaveButton {...saveButtonProps} />
        </>
      )}
      headerButtons={({ refreshButtonProps }) => <RefreshButton {...refreshButtonProps} />}>
      {query?.data && (
        <ShipperForm formProps={formProps} edit initialValuesModified={initialValuesModified} />
      )}
    </Edit>
  );
};

export default ShipperEdit;
